import Yup from '../../../../vendor/yup';
import { isSmallerThan } from '../../../../const/targetValidation';
import { SEMVER_REGEX } from '../../../../const/system';



export const mkValidationSchema = Yup.lazy((values) => {
  return Yup.object().shape({
    push_notification_id: Yup.number().required('Push notification is required'),
    is_published: Yup.bool().nullable(),
    use_utc_zero_time: Yup.bool(),
    scheduled_at: Yup.date().required(),
    min_version: Yup.string()
      .nullable()
      .matches(
        SEMVER_REGEX,
        'Min version has incorrect format. Try semantic version like 1.0 or 1.0.0',
      )
      .test(
        'check-min-version',
        'Min version should be less than or equal to the max version',
        (value) => {
          const maxValue = values.max_version;

          if (value && maxValue) {
            return isSmallerThan(value, maxValue) || value === maxValue;
          }

          return true;
        },
      ),
    max_version: Yup.string()
      .nullable()
      .matches(
        SEMVER_REGEX,
        'Max version has incorrect format. Try semantic version like 1.0 or 1.0.0',
      )
      .test(
        'check-max-version',
        'Max version should be greater than or equal to the min version',
        (value) => {
          const minValue = values.min_version;

          if (value && minValue) {
            return isSmallerThan(minValue, value) || value === minValue;
          }

          return true;
        },
      ),
    platform: Yup.array().of(Yup.string()),
    countries: Yup.array().of(Yup.string()),
    languages: Yup.array().of(Yup.string()),
  });
});
